import { me } from "@api/users/me/path";
import { register } from "@api/users/register/path";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { bulk } from "@api/users/bulk/path";
import type { IExtractParams } from "@/routes";
import { setPassword } from "@api/users/setPassword/path";
import { stats } from "@api/users/stats/path";

const pathBase = `/users/`;
const pathById = `${pathBase}:userId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const users = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  bulk,
  me,
  register,
  setPassword,
  stats,
};
